import { ImportMarketplaceOrdersOption } from './import-marketplace-orders-option';
import { SetupMarketplacePane } from './setup-marketplace-pane';
import { SimplifiedOrderImportDropdown } from './simplified-order-import-dropdown';
import { useShippingVolumeCategory } from '../../../../../../hooks/use-shipping-volume-category';

import type { ImportReadyCallbacks } from './types';

type Store = {
  isActive: boolean;
  isManualStore: boolean;
  marketplaceId: number;
};

type OrderImportSectionProps = {
  activeStores: Store[];
  onCsvFileChange?: (hasCsvFile: boolean) => void;
  onImportReadyChange?: (importReady: ImportReadyCallbacks | null) => void;
  onManualOrderAdded?: (hasManualOrder: boolean) => void;
};

export const OrderImportSection = ({ activeStores, onCsvFileChange, onImportReadyChange, onManualOrderAdded }: OrderImportSectionProps) => {
  const { isSmallTrialer } = useShippingVolumeCategory();
  const hasNoStores = activeStores.length === 0;

  if (!hasNoStores) {
    return <ImportMarketplaceOrdersOption activeStores={activeStores} />;
  }

  if (isSmallTrialer) {
    return (
      <SimplifiedOrderImportDropdown
        onCsvFileChange={onCsvFileChange}
        onImportReadyChange={onImportReadyChange}
        onManualOrderAdded={onManualOrderAdded}
      />
    );
  }

  return <SetupMarketplacePane />;
};
